<template>
  <div class="label-group">
    <div class="label-container">
      <div class="index-label-text-container">
        <span class="label-title">{{ scaleTitle }}</span>
        <span class="label-value">{{ scaleValue }}</span>
      </div>
    </div>
    <div class="label-container" v-for="label of labels" :key="label.label">
      <div class="label-color" :style="{ 'background-color': label.borderColour }"></div>
      <div class="label-text-container">
        <span class="label-title">{{ label.label }}</span>
        <span class="label-value">{{ label.value }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const props = defineProps({
  reportId: {
    type: String,
    required: true,
  },
});

const store = useStore();
const getReportLabels = (reportId: string) => computed(() => store.getters.getReportLabels(reportId));

const reportLabels = computed(() => getReportLabels(props.reportId).value);
const labels = computed(() => {
  if (reportLabels.value) {
    return reportLabels.value.reverse ? reportLabels.value.labels.slice().reverse() : reportLabels.value.labels;
  }
  return [];
});

const scaleTitle = computed(() => reportLabels.value?.scaleTitle || '-');
const scaleValue = computed(() => reportLabels.value?.scaleValue || '-');
</script>

<style scoped lang="scss">
.label-group {
  display: flex;
  flex-wrap: wrap;
  align-self: flex-start;
}
.label-container {
  display: flex;
  margin-bottom: 0.5em;

  &:not(:last-child) {
    margin-right: 1em;
  }
}
.label-color {
  width: 10px;
}
.label-text-container,
.index-label-text-container {
  display: flex;
  flex-direction: column;
  padding: 6px 16px;
  min-width: 6em;
}
.label-text-container {
  background-color: #f5f5f5;
}
.label-title {
  font-size: 0.8em;
}
.label-value {
  font-size: 1.5em;
}

.label-title,
.label-value {
  line-height: 1.2em;
}
</style>
